import { render } from "./FollowProjectButton.vue?vue&type=template&id=54e6ae38"
import script from "./FollowProjectButton.vue?vue&type=script&lang=js"
export * from "./FollowProjectButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__